import { render } from "./MessageInfoModal.vue?vue&type=template&id=2b9c3b9c&scoped=true&ts=true"
import script from "./MessageInfoModal.vue?vue&type=script&lang=ts"
export * from "./MessageInfoModal.vue?vue&type=script&lang=ts"

import "./MessageInfoModal.vue?vue&type=style&index=0&id=2b9c3b9c&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9c3b9c"]])

export default __exports__